<template>
    <UiMultiColumnsLayout :blok="blok" />
</template>

<script setup lang="ts">
import type { IMultiColumnsLayout } from '@nuxt-monorepo/ui/types/components/MultiColumnsLayout';

defineProps<{ blok: IMultiColumnsLayout }>();
</script>

<style scoped lang="postcss">
:deep(.container) {
    @apply mx-auto px-4;
}

.multi-column-layout {
    @apply bg-transparent;
    :deep(&.hide-on-mobile) {
        @apply hidden md:block;
    }
    :deep(&.hide-on-desktop) {
        @apply block md:hidden;
    }

    :deep(.slot) {
        @apply max-md:col-auto !important;
    }
    :deep(.grid-wrapper) {
        @apply gap-x-[44px] md:gap-y-[0] gap-y-[33px];
    }

    :deep(.section-subtitle) {
        @media screen and (max-width: 768px) {
            @apply text-center !important;
        }
        @apply block text-base leading-[18px] font-normal text-body mt-0 mb-6 mx-0;
    }
}
</style>
